import { useContext } from 'react';
import { FlavoursContext } from '@context';

export const useFlavoursContext = () => {
  const context = useContext(FlavoursContext);
  return context;
};
